var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdateSubscription(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#777777;stroke-width:4;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.4,22.1C5.7,13.5,12,6.3,21,4.3c11.4-2.4,22.6,4.8,25,16.2 M1.9,16.6l1.3,5.7l5.7-1.3 M4,29.5 c2.4,11.4,13.7,18.6,25,16.2c9-2,15.4-9.2,16.5-17.8 M48.1,33.4l-1.3-5.7l-5.7,1.3 M25.3,11.3v3.4 M25.3,35.1v3.5 M19.3,29.7 c0,3,2.5,5.5,5.7,5.5s5.7-2.4,5.7-5.5c0-1.6-1.4-5-5.5-5.4c-3.8-0.4-5.1-3.5-5.1-4.8c0-2.7,2.3-4.8,5-4.8s5,2.1,5,4.8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateSubscription);
export default __webpack_public_path__ + "static/media/update_subscription.a7f0a257467a86916b992921146836b4.svg";
export { ForwardRef as ReactComponent };